
    <main class="w-full px-4">
      <router-outlet></router-outlet>
    </main>
  